import { useRef } from "react";

export const useScroll = () => {
  const scrollableRef = useRef<HTMLDivElement | null>(null);
  const targetRef = useRef<Record<string | number, HTMLDivElement | null>>({});

  const handleScrollToElement = (targetId: string | number) => {
    const scrollableDiv = scrollableRef.current;
    const targetElement = targetRef.current[targetId];

    if (!scrollableDiv || !targetElement) return;

    scrollableDiv.scrollTo({
      top: targetElement.offsetTop - scrollableDiv.offsetTop,
      behavior: "smooth",
    });
  };

  const resetScroll = () => {
    scrollableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return { scrollableRef, targetRef, handleScrollToElement, resetScroll };
};
